import React, { Component } from 'react';
import { Table, Button, Segment, Form, Pagination, Dropdown, Input, Modal, Label, TextArea, Accordion, Icon } from 'semantic-ui-react';
import { post } from '../../util/api';
import _ from 'lodash';

export default class AccountOptions extends Component {
	state = {
		searchType: 'both',
		loading: true,
		loadingAccount: null,
		column: 'token',
		direction: 'desc',
		selectedAccount: null,
		page: 1,
		limit: 20,
		total: 0,
		totalPages: 0,
		searchToken: '',
		searchTimeout: null,
		isModalOpen: false,
		isClientModalOpen: false,
		isStaticOptionsModalOpen: false,
		isArrayEditModalOpen: false,
		currentEditingArray: null,
		currentEditingArrayKey: null,
		isEditing: false,
		editedData: null,
		editingSection: null,
		isSaving: false,
		saveError: null,
		saveMessage: null,
		activeBotInfo: false,
		activeBotsList: false,
		featureFilterType: 'different',
		availableFeatures: [
			{ key: 'default_payload', label: 'default_payload', type: 'string', defaultValue: '__ignore_payload' },
			{ key: 'sizelessColorlessProduct', label: 'Sipariş detayda beden ve renk bilgisi olmayan ürünler', type: 'boolean', defaultValue: true },
			{ key: 'edit_item_count', label: 'Sepetteki ürünün sayısını değiştirebilme', type: 'boolean', defaultValue: true },
			{
				key: 'excel_label',
				label: 'Konuşma oluşturmada agenta label tanımlanmışsa excelde sadece o labela sahip olanları görme',
				type: 'boolean',
				defaultValue: true,
			},
			{ key: 'wapi_create_with_tag', label: 'Wapi konuşması oluşturken telefon idyi konuşmaya tag olarak atama', type: 'boolean', defaultValue: true },
			{ key: 'silent_mode', label: 'silent_mode', type: 'boolean', defaultValue: false },
			{ key: 'selectpopup', label: 'selectpopup', type: 'boolean', defaultValue: true },
			{
				key: 'url_sources',
				label: 'url_sources',
				type: 'array',
				defaultValue: [
					{ url: 'instreet.com.tr', label: 'Instreet', color: '#000' },
					{ url: 'flo.com.tr', label: 'Flo', color: '#FF671D' },
				],
			},
			{ key: 'show_message_timestamp_second', label: 'Mesajlarda saniyeyi de gösterme', type: 'boolean', defaultValue: true },
			{ key: 'waba_gen_id', label: 'waba_gen_id', type: 'number', defaultValue: 1.0 },
			{ key: 'hide_links', label: 'hide_links', type: 'string', defaultValue: 'denizbutik' },
			{ key: 'translate', label: 'Çeviri açma', type: 'boolean', defaultValue: true },
			{ key: 'createWithWapi', label: 'Wapi konuşma başlatma', type: 'boolean', defaultValue: false },
			{
				key: 'stag',
				label: 'stag',
				type: 'array',
				defaultValue: [
					{ _id: '61f151ca3bd8fd1fccec376b', title: 'Bölge Müdürü', color: '#ed5565', pid: '01f039e0-7eaf-11ec-ad38-43a120f13824', active: false },
					{ _id: '61f151ca3bd8fd1fccec376c', title: 'Diyabet', color: '#5d9cec', pid: '01f039e0-7eaf-11ec-ad38-43a120f13824', active: false },
					{ _id: '61f151ca3bd8fd1fccec376d', title: 'Saha Ekibi', color: '#a0d468', pid: '01f039e0-7eaf-11ec-ad38-43a120f13824', active: false },
					{ _id: '61f151ca3bd8fd1fccec376e', title: 'Finance', color: '#FFCE54', pid: '01f039e0-7eaf-11ec-ad38-43a120f13824', active: false },
					{ _id: '61f8d5f11b98bf1f90b922ba', active: false, color: '#5d9cec', pid: '01f039e0-7eaf-11ec-ad38-43a120f13824', title: 'test' },
					{ _id: '61fa730e338203204058a4d8', active: false, color: '#5d9cec', pid: '01f039e0-7eaf-11ec-ad38-43a120f13824', title: 'test1' },
				],
			},
			{ key: 'nodeeplink', label: 'nodeeplink', type: 'boolean', defaultValue: true },
			{ key: 'open_search_button', label: 'Ürün aramaya buton ekleme', type: 'boolean', defaultValue: true },
			{ key: 'hide_all', label: "Konuşma listelerinde Hepsi'yi gizleme", type: 'boolean', defaultValue: true },
			{ key: 'edit_discount', label: 'Sepet indirim düzenleme', type: 'boolean', defaultValue: true },
			{ key: 'createGroupWhatsappName', label: 'Yeni konuşmayı grup olarak açma', type: 'string', defaultValue: 'NORA-' },
			{ key: 'forward_group', label: 'Konuşmayı gruplara aktarabilme', type: 'boolean', defaultValue: true },
			{ key: 'stock_info_popup', label: 'Stok bildirme butonu', type: 'boolean', defaultValue: true },
			{ key: 'hide_busy', label: 'Agent durumlarında meşgulü gizleme', type: 'boolean', defaultValue: true },
			{ key: 'hide_phone_view', label: 'Kişilerin telefon numaralarını gizleme', type: 'boolean', defaultValue: false },
			{
				key: 'miss_call_message',
				label: 'Cevapsız aramalarda mesaj gönderme',
				type: 'string',
				defaultValue:
					'Modatrend’e Hoşgeldiniz; Bu numaradan sadece WhatsApp mesajlarına cevap verilmektedir. Bu numaraya mesaj yazabilirsiniz. Mesajınıza mesai saatleri içerisinde ve yoğunluğa göre sırayla cevap verilmektedir. Eğer modatrend müşteri hizmetlerini aramak isterseniz, mesai saatleri içerisinde 0850 346 88 99 arayabilirsiniz. \r\nMesai saatlerimiz: \r\nHafta içi   : 08:30——18:30\r\nCumartesi: 08:30——15:30',
			},
			{ key: 'bot_active', label: 'bot_active', type: 'boolean', defaultValue: true },
			{
				key: 'micro_image_detect',
				label: 'micro_image_detect',
				type: 'string',
				defaultValue:
					'https://micro.yapaytech.com/api/ecommerce/5f8dbdc560e4f7d3e00876b8ab5f2ecf/widget/image?token=bRzxSV7xGkHNp44xsn6yAjjFVSeLgJn7nwtd',
			},
			{ key: 'typing_v2', label: 'Yazıyor görünmesini açma', type: 'boolean', defaultValue: true },
			{ key: 'showusernumber', label: 'showusernumber', type: 'boolean', defaultValue: true },
			{ key: 'phone_id_tags', label: 'phone_id_tags', type: 'array', defaultValue: [] }, // array içi boş
			{
				key: 'closeTags',
				label: 'closeTags',
				type: 'array',
				defaultValue: [
					{ id: 'tagg', title: 'tagg' },
					{ id: 'taggg', title: 'taggg' },
					{ id: 'siparis', title: 'Sipariş', label: 'sale' },
				],
			},
			{
				key: 'agent_statuses',
				label: 'agent_statuses',
				type: 'array',
				defaultValue: [
					{ title: 'Kısa Mola', value: 'kisa_mola' },
					{ title: 'Yemek Molası', value: 'yemek_mola' },
					{ title: 'Toplantı', value: 'toplanti' },
					{ title: 'Backoffice', value: 'backoffice' },
					{ title: 'offline', value: 'offline' },
				],
			},
			{ key: 'listen_agent_click', label: 'listen_agent_click', type: 'boolean', defaultValue: true },
			{
				key: 'bgcss',
				label: 'bgcss',
				type: 'string',
				defaultValue: 'background: url(https://cdn.yapaytech.com/tazebg2.jpg) no-repeat;background-size: cover;',
			},
			{ key: 'excel_create_phone', label: 'Konuşma başlatırken excel listesini kullanma', type: 'boolean', defaultValue: false },
			{
				key: 'extension_templates',
				label: 'extension_templates',
				type: 'array',
				defaultValue: [
					{ id: 1.0, name: 'T1', type: 'text', text: 'hi {{1}} test message' },
					{ id: 2.0, name: 'T2', type: 'text', text: '{{1}} asd {{2}}' },
				],
			},
			{ key: 'deeplink', label: 'deeplink', type: 'string', defaultValue: 'https://www.watsons.com.tr' },
			{ key: 'maytapi_pid', label: 'maytapi_pid', type: 'string', defaultValue: 'a24169fa-b7a8-486b-9358-9dcb7724b768' },
			{ key: 'instagram_bot_active', label: 'Tanımlı botun instagramda çalışması', type: 'boolean', defaultValue: true },
			{ key: 'facebook_bot_active', label: 'Tanımlı botun facebook yorumlarında çalışması', type: 'boolean', defaultValue: false },
			{ key: 'ignoreTakeConv', label: 'Konuşma oluşturmada başkasının üstündekini konuşmayı almayı engelleme', type: 'boolean', defaultValue: true },
			{ key: 'add_agent_note', label: 'Sipariş oluşturmada not olarak agent mail adresinin eklenmesi', type: 'boolean', defaultValue: true },
			{ key: 'hijacklogout', label: 'Logout yaparken tüm konuşmalardan çıkılsınmı diye sorulması', type: 'boolean', defaultValue: true },
			{
				key: 'tags',
				label: 'tags',
				type: 'array',
				defaultValue: [
					{ _id: '60db1bac5bc07b44b0d10bc7', active: true, color: '#5d9cec', pid: 'a1ad83bda34414bf5a605c64b81b9c14', title: 'test1' },
					{ _id: '61111cc1dc967f3619131852', active: true, color: '#ED5565', pid: 'a1ad83bda34414bf5a605c64b81b9c14', title: 'Satış' },
				],
			},
			{
				key: 'close_parser_config',
				label: 'close_parser_config',
				type: 'array',
				defaultValue: [
					{
						regex: '(?:Toplamı?|Ödeme)\\s?(.*?)(?:\\s|\\n|$)',
						type: 'order',
						key: 'order',
						display: 'Sipariş Alındı:\nKod: {{code}}\nTutar: {{amount}}',
						version: 2,
						list: [],
					},
				],
			},
			{ key: 'start_auto_take', label: 'Otomatik atamada deneme süresi', type: 'number', defaultValue: 10000 },
			{ key: 'fulltyping', label: 'Yazıyor görünmesini açma', type: 'boolean', defaultValue: true },
			{ key: 'hide_agents', label: 'Konuşma listesinde Agentları gizleme', type: 'boolean', defaultValue: true },
			{ key: 'throttle_minute', label: 'Telefondan konuşma oluşturmak için bekleme süresi', type: 'number', defaultValue: 5.0 },
			{ key: 'ai_editor', label: 'Textleri düzenlemesi için AI butonu açma', type: 'boolean', defaultValue: true },
			{ key: 'same_phone', label: 'Konuşma geçmişini çekerken phone id ye göre filtreleme', type: 'boolean', defaultValue: true },
			{ key: 'showSendStart', label: 'Karşılama mesajı yollama butonu açma', type: 'boolean', defaultValue: false },
			{ key: 'mobileNotification', label: 'Mobil uygulama bildirim açma', type: 'boolean', defaultValue: true },
			{ key: 'create_with_group', label: 'Yeni konuşmayı grup olarak açma', type: 'boolean', defaultValue: true },
			{ key: 'maytapi_multi', label: 'Farklı telefonlar varsa konuşmaları phone id ye göre açma', type: 'boolean', defaultValue: true },
			{
				key: 'groups',
				label: 'groups',
				type: 'array',
				defaultValue: [
					{ id: 'test1', label: 'Test_1', svg: 'accountwait', and: ['waiting'], check: { group: 'test1' } },
					{ id: 'test2', label: 'Test_2', svg: 'accountwait', and: ['waiting'], check: { group: 'test2' } },
				],
			},
			{
				key: 'shortMessages',
				label: 'shortMessages',
				type: 'array',
				defaultValue: [{ type: 'text', text: 'Merhaba, size nasıl yardımcı olabilirim?', preview: 'merhaba' }],
			},
			{ key: 'maytapi', label: 'maytapi', type: 'boolean', defaultValue: true },
			{ key: 'edit_discount_ratio', label: 'Sepet indirimini yüzdelik olarak düzenleme', type: 'boolean', defaultValue: true },
			{ key: 'force_can_reply', label: 'Plarformdan bağımsız reply yapabilme', type: 'boolean', defaultValue: true },
			{ key: 'silent_agent', label: 'Bildirim seslerini kapatma', type: 'boolean', defaultValue: false },
			{ key: 'filter_instagram', label: 'Konuşma listesinde Instagramın görünmesi', type: 'boolean', defaultValue: true },
			{
				key: 'widget_config',
				label: 'widget_config',
				type: 'object',
				defaultValue: {
					label: true,
					ecommerce: true,
					tiers: [
						{ ext_id: 5, selected_tier: 'label' },
						{ ext_id: 7, selected_tier: 'ecommerce' },
					],
					sub: { status: 'active', trial: false },
				},
			},
			{ key: 'whatsapp_bot', label: 'whatsapp_bot', type: 'boolean', defaultValue: true },
			{ key: 'close_data_required', label: 'Konuşma kapatırken zorunlu alanların doldurulması', type: 'boolean', defaultValue: true },
			{
				key: 'custom_emoji',
				label: 'custom_emoji',
				type: 'array',
				defaultValue: {
					title: ['Emoji'],
					list: [
						[
							['😄', 'smile'],
							['😃', 'smiley'],
							['😀', 'grinning'],
						],
					],
				},
			},
			{
				key: 'instagram_comment_reply',
				label: 'Instagram dm cevap mesajı atarken yoruma gidecek mesaj',
				type: 'string',
				defaultValue: 'Mesaj kutunuzu kontrol edebilirsiniz 📩🧡',
			},
			{ key: 'sale_addressno_optional', label: 'sale_addressno_optional', type: 'boolean', defaultValue: true },
			{ key: 'instagram_comments', label: 'Instagram yorumlarının livechate düşmesini açma', type: 'boolean', defaultValue: true },
			{ key: 'facebook_comments', label: 'Facebook yorumlarının livechate düşmesini açma', type: 'boolean', defaultValue: false },
			{ key: 'enable_tag_comment', label: 'enable_tag_comment', type: 'boolean', defaultValue: true },
			{ key: 'emoji', label: 'Agentların emoji yollamasını açma', type: 'boolean', defaultValue: false },
			{ key: 'instagramComment', label: 'instagramComment', type: 'boolean', defaultValue: true },
			{ key: 'dontShowCargp', label: 'Sipariş detayda kargo kısmını kapatma', type: 'boolean', defaultValue: true },
			{ key: 'filter_telegram', label: 'Konuşma listesinde telegram filtresini açma', type: 'boolean', defaultValue: true },
			{ key: 'old_list_open_web', label: 'Web konuşmalarında geçmiş konuşmaları getirme', type: 'boolean', defaultValue: true },
			{ key: 'close', label: 'Konuşma listesinde kapalıları gösterme', type: 'boolean', defaultValue: true },
			{ key: 'disable_forward', label: 'Agentların konuşma aktarmasını kapatma', type: 'boolean', defaultValue: true },
			{ key: 'close_static_regex', label: 'Kapatmada regex ile sipariş detay yakalama', type: 'boolean', defaultValue: true },
			{ key: 'ty_questions', label: 'Konuşma listesinde trendyol sorularını gösterme', type: 'boolean', defaultValue: true },
			{ key: 'editCurrency', label: 'Dövizle ürün bilgisi dönenlerde kuru güncelleme', type: 'boolean', defaultValue: true },
			{ key: 'disable_auto_send', label: 'Hazır cevaplarda direkt göndermeyi gizleme', type: 'boolean', defaultValue: true },
			{ key: 'hide_closed', label: 'Konuşma listesinde kapalıları gizleme', type: 'boolean', defaultValue: true },
			{ key: 'conv_take_limit', label: 'Otomatik atamada üzerine alınabilecek konuşma limiti', type: 'number', defaultValue: 15.0 },
			{ key: 'attach', label: 'Dosya gönderimini açma', type: 'boolean', defaultValue: true },
			{ key: 'search_hide_closed', label: 'Aramalarda kapalıların gelmemesi', type: 'boolean', defaultValue: true },
			{
				key: 'havale_custom_text',
				label: 'Havale ödeme bilgisi',
				type: 'string',
				defaultValue:
					'\nHesap No: 6298132\r\nIBAN:TR440006200066100006298132\r\nHesap Adı:MİRO KOZMETİK HİJYEN DIŞ TİCARET LTD.ŞTİ.\r\nsiparişinizi onaylıyorsanız iletmiş olduğumuz iban bilgilerine ödeme sonrası dekont iletebilir misiniz?',
			},
			{
				key: 'widgets',
				label: 'widgets',
				type: 'array',
				defaultValue: [
					{
						type: 'menu',
						list: [
							{
								title: 'İsim Sor',
								icon: 'address-card-o',
								action: {
									type: 'text',
									text: 'İsim ve soy isminizi girebilir misiniz?',
									params: { type: 'step', key: 'isim' },
								},
							},
							{
								title: 'Adres Sor',
								icon: 'map-marker',
								action: {
									type: 'text',
									text: 'Sipariş oluşturabilmemiz için tek satırda Açık Adres, İl ve İlçe iletebilir misiniz?',
									params: { type: 'step', key: 'adres' },
								},
							},
							{
								title: 'Ödeme Yöntemi',
								icon: 'credit-card',
								action: {
									type: 'text',
									text: 'Kapıda Ödeme (Siparişe 7TL Kapıda Ödeme Bedeli Yansır)\nKapıda Kredi kartı ile Ödeme (Siparişe 7TL Kapıda Ödeme Bedeli Yansır)\nSiparişinizi nasıl ödemek istiyorsunuz?',
									params: { type: 'step', key: 'odeme' },
								},
							},
							{
								title: 'Sipariş Onayı',
								icon: 'check',
								action: {
									type: 'text',
									text: 'Siparişi onaylıyor musunuz?',
									params: { type: 'step', key: 'siparis' },
								},
							},
							{
								title: 'Beden Sor',
								icon: 'female',
								action: {
									type: 'text',
									text: 'Hangi bedeni almak istiyorsunuz?',
									params: { type: 'step', key: 'beden' },
								},
							},
							{
								title: 'Renk Sor',
								icon: 'eyedropper',
								action: {
									type: 'text',
									text: 'Hangi rengi almak istiyorsunuz?',
									params: { type: 'step', key: 'renk' },
								},
							},
						],
					},
				],
			},
			{ key: 'wapi_create', label: 'wapi_create', type: 'boolean', defaultValue: true },
			{ key: 'on_close_actions', label: 'Kapatmalarda anket gönderimini açma', type: 'boolean', defaultValue: true },
			{
				key: 'surveyText',
				label: 'Whatsapp konuşmalarında anket mesajı',
				type: 'string',
				defaultValue:
					'Görüşmemizi değerlendirmeniz beni çok mutlu eder. Aşağıdaki linke tıklayabilirsiniz. Ayıracağınız vakit için çok teşekkür ederiz. 🥰\n__url__',
			},
			{ key: 'micro', label: 'micro', type: 'boolean', defaultValue: true },
			{ key: 'close_hard_limit', label: 'close_hard_limit', type: 'boolean', defaultValue: true },
			{ key: 'mine_notification', label: 'mine_notification', type: 'boolean', defaultValue: true },
			{ key: 'currency', label: 'currency', type: 'boolean', defaultValue: true },
			{ key: 'cart_address_none', label: 'Adressiz sipariş', type: 'boolean', defaultValue: true },
			{ key: 'favori_before_history', label: 'Ürün göndermede favorilerin üste gelmesi', type: 'boolean', defaultValue: true },
			{ key: 'open_ecommerce_user_id', label: 'Kullanıcı bilgilerinde altyapıdaki bilgilerini gösterme', type: 'boolean', defaultValue: true },
			{ key: 'hide_links_v2', label: 'Linkleri gizleme', type: 'string', defaultValue: 'denizbutik|bit.ly|instagram|facebook' },
			{ key: 'from_cdn', label: 'from_cdn', type: 'boolean', defaultValue: true },
			{ key: 'wa_templates', label: 'wa_templates', type: 'array', defaultValue: [] }, // array içi boş
			{ key: 'agentSellingData', label: 'Agentların satış bilgiler', type: 'boolean', defaultValue: false },
			{ key: 'auto_close_week_instagram2', label: 'auto_close_week_instagram2', type: 'boolean', defaultValue: true },
			{ key: 'wa_gen_id', label: 'wa_gen_id', type: 'number', defaultValue: 45.0 },
			{ key: 'show_waiting', label: 'Bekleyenleri gösterme', type: 'boolean', defaultValue: true },
			{ key: 'address_tax_no', label: 'Adrese vergi bilgisi girişi ekleme', type: 'boolean', defaultValue: true },
			{ key: 'order_custom_note_text', label: 'Sipariş detaya custom mesaj ekleme', type: 'string', defaultValue: 'Kargo ücreti alıcı ödemelidir.' },
			{ key: 'bot_input_disabled', label: 'bot_input_disabled', type: 'boolean', defaultValue: true },
			{ key: 'countStatesInWeek', label: 'countStatesInWeek', type: 'number', defaultValue: 52.0 },
			{ key: 'filter_discord', label: 'Konuşma listesine discord ekleme', type: 'boolean', defaultValue: 'true' },
			{ key: 'coupon_input', label: 'Sepete kupon ekleme', type: 'boolean', defaultValue: true },
			{ key: 'excel_create_telegram', label: 'Telegramla excel listesinde konuşma başlatma', type: 'boolean', defaultValue: true },
			{ key: 's_ame_phone', label: 's_ame_phone', type: 'boolean', defaultValue: true },

			{
				key: 'teams',
				label: 'teams',
				type: 'array',
				defaultValue: [
					{ id: 'teleperformans', label: 'Teleperformans' },
					{ id: 'global_bilgi', label: 'Turkcell Global-Bilg' },
					{ label: 'FLO Yönetim', id: 'flo_yonetim' },
				],
			},
			{
				key: 'phone_groups',
				label: 'Telefon bazlı gruplama: her numara bir grup (phone_<id>), konuşma numarasının grubuna düşer. Settings > Agents sayfasından yönetilir',
				type: 'array',
				defaultValue: [{ id: 12345, label: 'Satış Hattı' }],
			},
			{ key: 'wapi_create_with_name', label: 'Konuşma oluşturmada kişi ismi ile oluşturma', type: 'boolean', defaultValue: true },
			{ key: 'hide_agents_button', label: 'Konuşma oluşturma tarafında olan butonları gizleme', type: 'boolean', defaultValue: true },
			{ key: 'lang_fixed', label: 'Default dili değiştirme', type: 'string', defaultValue: 'en' },
			{ key: 'auto_close_week_instagram', label: 'auto_close_week_instagram', type: 'boolean', defaultValue: true },
			{ key: 'hide_user_info', label: 'Kullanıcı bilgileini gizleme', type: 'boolean', defaultValue: true },
			{ key: 'filter_facebook', label: 'Konuşma listesinde facebook filtresini açma', type: 'boolean', defaultValue: true },
			{ key: 'createGroupWhatsapp', label: 'Yeni konuşmayı grup olarak açma', type: 'boolean', defaultValue: true },
			{ key: 'auto_take_global', label: 'Otomatik dağıtımı açma', type: 'boolean', defaultValue: true },
			{
				key: 'search',
				label: 'search',
				type: 'object',
				defaultValue: {
					product: 'https://template.dahi.ai/service/5eb8eb23d04e47616eb9a272?s=1&query={{query}}',
				},
			},
			{
				key: 'ms_dropdown',
				label: 'ms_dropdown',
				type: 'array',
				defaultValue: [
					{
						required: { host: '(https://www.derimod.com.tr)' },
						check_url: true,
						title: 'Ürün Bilgileri',
						auto: true,
						url: 'https://template.dahi.ai/service/5f4a41b2428bd02859eb4c69',
					},
				],
			},
			{ key: 'disable_create', label: 'Yeni konuşma açmayı engelleme', type: 'boolean', defaultValue: true },
			{ key: 'getConversations_limit', label: 'Search sonucu gelecek konuşma limiti', type: 'number', defaultValue: 1000.0 },
			{ key: 'ignore_agent_amount', label: 'ignore_agent_amount', type: 'boolean', defaultValue: true },
			{ key: 'cart_history_enabled', label: 'Sipariş oluşturma açılmamışlarda sadece geçmiş siparişleri açma', type: 'boolean', defaultValue: true },
			{ key: 'maytapi_ack', label: 'maytapi_ack', type: 'boolean', defaultValue: true },
			{ key: 'busy_warning', label: 'Meşgulde nelirli süre sonra agenta uyarı çıkması', type: 'number', defaultValue: 600000.0 },
			{ key: 'sendFlo', label: 'sendFlo', type: 'boolean', defaultValue: true },
			{ key: 'take_one_add_sec', label: 'Üzerindeki konuşma sayısına göre tekrar denemelere eklenecek süre', type: 'number', defaultValue: 5000.0 },
			{ key: 'generic_adress', label: 'Adres girmede ülke de sorma', type: 'boolean', defaultValue: true },
			{ key: 'open_instagram_comment_reply', label: 'Yoruma Dm olarak cevap verme', type: 'boolean', defaultValue: true },
			{ key: 'instagram_comment_reply_comment', label: 'Yoruma yorum olarak cevap verme', type: 'boolean', defaultValue: true },
			{ key: 'turbolinks', label: 'turbolinks', type: 'boolean', defaultValue: true },
			{ key: 'language', label: 'Dil', type: 'string', defaultValue: 'en' },
			{ key: 'releaseBotWhenFromMe', label: 'releaseBotWhenFromMe', type: 'boolean', defaultValue: true },
			{ key: 'disable_whatsapp_group_bot', label: 'Botun gruplara cevap vermesini kapatma', type: 'boolean', defaultValue: true },
			{ key: 'throttle_create', label: 'Wapi konuşması başlatırken arada süre olma zorunluluğu', type: 'boolean', defaultValue: true },
			{ key: 'auto_two_days_instagram', label: 'auto_two_days_instagram', type: 'boolean', defaultValue: true },
			{ key: 'show_agents', label: 'Agentları gösterme', type: 'boolean', defaultValue: true },
			{ key: 'sizelessProduct', label: 'Sipariş detayda bedensiz ürünler', type: 'boolean', defaultValue: true },
			{ key: 'show_unanswer', label: 'Cevaplanmamışları göster', type: 'boolean', defaultValue: true },
			{ key: 'idle_time', label: 'Agentın hiç bişey yapmadığında idle a düşme süresi', type: 'number', defaultValue: 5.0 },
			{ key: 'lang', label: 'lang', type: 'string', defaultValue: 'tr' },
			{ key: 'admin_show_phone_view', label: 'Telefon gizlenmişlerde sadece adminlere açma', type: 'boolean', defaultValue: true },
			{ key: 'disable_auto_price', label: 'Karttan fiyat yakalamayı kapat', type: 'boolean', defaultValue: true },
			{ key: 'same_platform', label: 'Eski konuşmaları çekerken aynı platform olması', type: 'boolean', defaultValue: true },
			{ key: 'hide_conversation_history', label: 'Konuşma geçmişini gizleme', type: 'boolean', defaultValue: true },
			{ key: 'editCargoPrice', label: 'Kargo fiyatını düzenleme', type: 'boolean', defaultValue: true },
			{
				key: 'langData',
				label: 'langData',
				type: 'object',
				defaultValue: {
					en: {
						sale_send_info_text:
							'Tebrikler, Siparişiniz başarılı bir şekilde oluşturulmuştur.\nSipariş No: {{no}}\nSipariş Adedi: 1\nParça adedi: {{count}}\nToplam fiyat: {{price}} {{currency}}\nwww.modatrend.com.tr yi tercih ettiğiniz için teşekkür ederiz.\nSipariş durumunu öğrenmek için bu linki kullanabilirsiniz.\nhttps://www.modatrend.com.tr/siparis-sorgulama-sayfasi?number={{phone}}',
					},
					tr: {
						sale_send_info_text:
							'Tebrikler, Siparişiniz başarılı bir şekilde oluşturulmuştur.\nSipariş No: {{no}}\nSipariş Adedi: 1\nParça adedi: {{count}}\nToplam fiyat: {{price}} {{currency}}\nwww.modatrend.com.tr yi tercih ettiğiniz için teşekkür ederiz.\nSipariş durumunu öğrenmek için bu linki kullanabilirsiniz.\nhttps://www.modatrend.com.tr/siparis-sorgulama-sayfasi?number={{phone}}',
					},
				},
			},
			{ key: 'hide_tags', label: 'hide_tags', type: 'boolean', defaultValue: true },
			{ key: 'payment_warning', label: 'Ödeme uyarı açma', type: 'boolean', defaultValue: false },
			{ key: 'payment_last_date', label: 'Ödeme yapılmazsa kapatılacak tarih saat', type: 'string', defaultValue: '' },
			{ key: 'auto_close_instagram_comment', label: 'auto_close_instagram_comment', type: 'boolean', defaultValue: true },
			{ key: 'waba_templates', label: 'waba_templates', type: 'array', defaultValue: [] },
		],
		selectedFeatures: {},
		originalData: [], // Orijinal veriyi tutmak için yeni state
		data: [],
		currentPageData: [],
	};

	componentDidMount() {
		this.getData();
	}

	async getData() {
		await post('/live/admin/dashboard').then((data) => {
			let processedData = _.map(data.data.result, function (it) {
				return {
					agent_limit: it.agent_limit || 0,
					token: it.token,
					stoken: it.pid,
					owner_id: it.owner_id,
					agents: it.agents,
					developer: it.owner_email,
					name: it.owner_name,
					_id: it.owner_id,
				};
			});

			const sortedData = _.orderBy(processedData, 'owner_id', 'desc');
			this.setState({
				originalData: sortedData,
				data: sortedData,
				loading: false,
				total: sortedData.length,
				totalPages: Math.ceil(sortedData.length / this.state.limit),
				currentPageData: sortedData.slice(0, this.state.limit),
			});
		});
	}

	handleSort = (clickedColumn) => () => {
		const { column, direction, data } = this.state;

		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				data: _.orderBy(data, [clickedColumn], ['asc']),
				direction: 'ascending',
				page: 1,
			});
			return;
		}

		this.setState({
			data: data.reverse(),
			direction: direction === 'ascending' ? 'descending' : 'ascending',
			page: 1,
		});
	};

	handlePageChange = (e, { activePage }) => {
		const { data, limit } = this.state;
		const startIndex = (activePage - 1) * limit;
		const endIndex = startIndex + limit;

		this.setState({
			page: activePage,
			currentPageData: data.slice(startIndex, endIndex),
		});
	};

	handleLimitChange = (e, { value }) => {
		this.setState({
			limit: value,
			page: 1,
			totalPages: Math.ceil(this.state.data.length / value),
			currentPageData: this.state.data.slice(0, value),
		});
	};

	handleSearchChange = (e, { value }) => {
		const { searchTimeout, originalData = this.state.data } = this.state;

		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const searchValue = value.trim();
		this.setState({ searchToken: value });

		if (!searchValue) {
			this.setState({
				data: originalData,
				total: originalData.length,
				totalPages: Math.ceil(originalData.length / this.state.limit),
				page: 1,
				currentPageData: originalData.slice(0, this.state.limit),
			});
			return;
		}

		const searchValueWithoutAt = searchValue.replace('@', '');
		if (searchValueWithoutAt.length > 0 && searchValueWithoutAt.length < 2) {
			return;
		}

		const newTimeout = setTimeout(() => {
			const searchLower = searchValue.toLowerCase();

			const filteredData = originalData.filter((account) => account.developer?.toLowerCase().includes(searchLower));

			this.setState({
				data: filteredData,
				searchTimeout: null,
				total: filteredData.length,
				totalPages: Math.ceil(filteredData.length / this.state.limit),
				page: 1,
				currentPageData: filteredData.slice(0, this.state.limit),
			});
		}, 500);

		this.setState({
			searchTimeout: newTimeout,
		});
	};

	selectAccount = async (account) => {
		this.setState({ loadingAccount: account._id });
		try {
			const response = await post('/dahi/message/admin/getAccountDetails', {
				pid: account.stoken,
			});

			if (response.data.success) {
				this.setState({
					selectedAccount: response.data.result,
					isModalOpen: true,
					loadingAccount: null,
				});
			} else {
				throw new Error(response.data.error || 'Hesap detayları alınamadı');
			}
		} catch (error) {
			console.error('Hesap detayları alınırken hata:', error);
			// Hata durumunda da modalı aç ama sadece mevcut account bilgilerini göster
			this.setState({
				selectedAccount: account,
				isModalOpen: true,
				loadingAccount: null,
			});
		}
	};

	closeModal = () => {
		this.setState({
			selectedAccount: null,
			isModalOpen: false,
			isClientModalOpen: false,
			isStaticOptionsModalOpen: false,
			editingSection: null,
			activeBotInfo: false,
			activeBotsList: false,
		});
	};

	openClientModal = () => {
		this.setState({
			isClientModalOpen: true,
			editingSection: 'client',
		});
	};

	openStaticOptionsModal = () => {
		this.setState({
			isStaticOptionsModalOpen: true,
			editingSection: 'staticOptions',
		});
	};

	handleEditToggle = (section) => {
		const { selectedAccount, isEditing } = this.state;

		if (!isEditing) {
			let editedData = null;
			let selectedFeatures = {};

			if (section === 'client' && selectedAccount.client) {
				editedData = _.cloneDeep(selectedAccount.client);
			} else if (section === 'staticOptions' && selectedAccount.staticOptions) {
				editedData = _.cloneDeep(selectedAccount.staticOptions);
				// Mevcut özellikleri selectedFeatures'a dönüştür
				this.state.availableFeatures.forEach((feature) => {
					if (editedData.hasOwnProperty(feature.key)) {
						selectedFeatures[feature.key] = editedData[feature.key];
					}
				});

				// Mevcut özellikleri otomatik olarak seç
				Object.keys(editedData).forEach((key) => {
					const feature = this.state.availableFeatures.find((f) => f.key === key);
					if (feature) {
						selectedFeatures[key] = editedData[key];
					}
				});
			}

			this.setState({
				isEditing: true,
				editedData,
				selectedFeatures,
				saveError: null,
			});
		} else {
			this.setState({
				isEditing: false,
				editedData: null,
				selectedFeatures: {},
				saveError: null,
			});
		}
	};

	handleDataChange = (path, value) => {
		this.setState((prevState) => ({
			editedData: _.set(_.cloneDeep(prevState.editedData), path, value),
		}));
	};

	handleSave = async () => {
		const { selectedAccount, selectedFeatures, editingSection } = this.state;

		this.setState({ isSaving: true, saveError: null });

		try {
			// Yeni bir editedData objesi oluştur
			const editedData = {};

			// Sadece seçili özellikleri ekle
			this.state.availableFeatures.forEach((feature) => {
				if (selectedFeatures.hasOwnProperty(feature.key)) {
					// Özellik seçiliyse, değerini ekle
					editedData[feature.key] = selectedFeatures[feature.key];
				}
			});

			// Diğer özellikleri ekle (availableFeatures listesinde olmayanlar)
			const currentData = selectedAccount[editingSection] || {};
			Object.entries(currentData).forEach(([key, value]) => {
				// Eğer bu özellik availableFeatures listesinde değilse, olduğu gibi koru
				if (!this.state.availableFeatures.find((f) => f.key === key)) {
					editedData[key] = value;
				}
			});

			const updateData = {
				token: selectedAccount.token,
				[editingSection]: editedData,
			};

			const response = await post('/dahi/message/admin/updateAccount', updateData);

			if (response.data.success) {
				this.setState((prevState) => ({
					selectedAccount: {
						...prevState.selectedAccount,
						[editingSection]: editedData,
					},
					data: prevState.data.map((account) =>
						account.token === selectedAccount.token
							? {
									...account,
									[editingSection]: editedData,
							  }
							: account
					),
					isEditing: false,
					editedData: null,
					selectedFeatures: {},
					isSaving: false,
				}));

				this.setState({
					saveMessage: {
						type: 'success',
						content: 'Değişiklikler başarıyla kaydedildi.',
					},
				});

				setTimeout(() => {
					this.setState({ saveMessage: null });
				}, 3000);
			} else {
				this.setState({
					saveError: response.data.error || 'Güncelleme sırasında bir hata oluştu.',
					isSaving: false,
				});
			}
		} catch (error) {
			this.setState({
				saveError: error.message || 'Güncelleme sırasında bir hata oluştu.',
				isSaving: false,
			});
		}
	};

	handleFeatureToggle = (key, type, defaultValue) => {
		this.setState((prevState) => ({
			selectedFeatures: {
				...prevState.selectedFeatures,
				[key]: defaultValue,
			},
		}));
	};

	handleFeatureValueChange = (key, value) => {
		this.setState((prevState) => ({
			selectedFeatures: {
				...prevState.selectedFeatures,
				[key]: value,
			},
		}));
	};

	// handleArrayEdit fonksiyonunu güncelle:
	handleArrayEdit = (key, value) => {
		if (key === 'custom_emoji') {
			// custom_emoji için özel format
			const emojiArray = value?.list?.[0] || value || [];
			this.setState({
				isArrayEditModalOpen: true,
				currentEditingArray: emojiArray,
				currentEditingArrayKey: key,
			});
		} else {
			// Diğer array'ler için normal işlem
			this.setState({
				isArrayEditModalOpen: true,
				currentEditingArray: value || [],
				currentEditingArrayKey: key,
			});
		}
	};

	// handleArraySave fonksiyonunu güncelle:
	handleArraySave = () => {
		const { currentEditingArray, currentEditingArrayKey } = this.state;

		if (currentEditingArrayKey === 'custom_emoji') {
			// custom_emoji için özel format
			const formattedValue = {
				title: ['Emoji'],
				list: [currentEditingArray],
			};
			this.handleFeatureValueChange(currentEditingArrayKey, formattedValue);
		} else {
			// Diğer array'ler için normal işlem
			this.handleFeatureValueChange(currentEditingArrayKey, currentEditingArray);
		}

		this.setState({
			isArrayEditModalOpen: false,
			currentEditingArray: null,
			currentEditingArrayKey: null,
		});
	};

	// renderArrayEditModal fonksiyonunu güncelle:
	renderArrayEditModal = () => {
		const { isArrayEditModalOpen, currentEditingArray, currentEditingArrayKey } = this.state;
		const feature = this.state.availableFeatures.find((f) => f.key === currentEditingArrayKey);

		if (!feature || !isArrayEditModalOpen) return null;

		return (
			<Modal open={isArrayEditModalOpen} onClose={() => this.setState({ isArrayEditModalOpen: false })} size="small">
				<Modal.Header>{feature.label} Düzenle</Modal.Header>
				<Modal.Content>
					<div style={{ maxHeight: '400px', overflowY: 'auto' }}>
						{currentEditingArrayKey === 'custom_emoji' ? (
							// Emoji düzenleme arayüzü
							<div>
								{currentEditingArray.map((item, index) => (
									<div key={index} style={{ marginBottom: '1em', display: 'flex', gap: '1em', alignItems: 'center' }}>
										<Input
											style={{ width: '80px' }}
											value={item[0]}
											onChange={(e) => {
												const newArray = [...currentEditingArray];
												newArray[index] = [e.target.value, item[1]];
												this.setState({ currentEditingArray: newArray });
											}}
											placeholder="Emoji"
										/>
										<Input
											style={{ flex: 1 }}
											value={item[1]}
											onChange={(e) => {
												const newArray = [...currentEditingArray];
												newArray[index] = [item[0], e.target.value];
												this.setState({ currentEditingArray: newArray });
											}}
											placeholder="Kod"
										/>
										<Button
											icon="trash"
											color="red"
											onClick={() => {
												const newArray = currentEditingArray.filter((_, i) => i !== index);
												this.setState({ currentEditingArray: newArray });
											}}
										/>
									</div>
								))}
								<Button
									icon="plus"
									content="Yeni Emoji Ekle"
									onClick={() => {
										this.setState({
											currentEditingArray: [...currentEditingArray, ['😊', 'new_emoji']],
										});
									}}
								/>
							</div>
						) : (
							// Diğer array'ler için normal düzenleme arayüzü
							<div>
								{currentEditingArray.map((item, index) => (
									<div key={index} style={{ marginBottom: '1em', display: 'flex', gap: '1em' }}>
										<TextArea
											style={{ flex: 1, fontFamily: 'monospace' }}
											value={JSON.stringify(item, null, 2)}
											onChange={(e) => {
												try {
													const newArray = [...currentEditingArray];
													newArray[index] = JSON.parse(e.target.value);
													this.setState({ currentEditingArray: newArray });
												} catch (err) {
													// JSON parse hatası durumunda değeri güncelleme
												}
											}}
											rows={5}
										/>
										<Button
											icon="trash"
											color="red"
											onClick={() => {
												const newArray = currentEditingArray.filter((_, i) => i !== index);
												this.setState({ currentEditingArray: newArray });
											}}
										/>
									</div>
								))}
								<Button
									icon="plus"
									content="Yeni Öğe Ekle"
									onClick={() => {
										const defaultItem =
											feature.defaultValue && feature.defaultValue[0]
												? { ...feature.defaultValue[0] }
												: { id: currentEditingArray.length + 1 };
										this.setState({
											currentEditingArray: [...currentEditingArray, defaultItem],
										});
									}}
								/>
							</div>
						)}
					</div>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={() => this.setState({ isArrayEditModalOpen: false })}>İptal</Button>
					<Button color="green" onClick={this.handleArraySave}>
						Kaydet
					</Button>
				</Modal.Actions>
			</Modal>
		);
	};

	renderFeatureList = (filteredFeatures = this.state.availableFeatures) => {
		const { selectedFeatures, isEditing, selectedAccount } = this.state;
		const currentData = selectedAccount?.staticOptions || {};

		return (
			<div
				style={{
					maxHeight: '350px',
					overflowY: 'auto',
					padding: '1em',
					backgroundColor: '#fff',
					borderRadius: '8px',
					border: '1px solid #edf2f7',
				}}
			>
				{filteredFeatures.map((feature) => {
					const isActive = isEditing ? selectedFeatures.hasOwnProperty(feature.key) : currentData.hasOwnProperty(feature.key);
					const value = isEditing ? selectedFeatures[feature.key] : currentData[feature.key];
					return (
						<div
							key={feature.key}
							style={{
								display: 'flex',
								alignItems: 'center',
								padding: '0.8em',
								borderBottom: '1px solid #edf2f7',
								gap: '1em',
								backgroundColor: isActive ? '#f0f9ff' : 'transparent',
								cursor: 'pointer',
							}}
							onClick={(e) => {
								if (!isEditing) return;
								const isRadioArea =
									e.target.closest('.ui.radio') ||
									e.target.closest('.ui.toggle') ||
									e.target.closest('.ui.input') ||
									e.target.tagName.toLowerCase() === 'input';

								if (isRadioArea) return;

								if (selectedFeatures.hasOwnProperty(feature.key)) {
									const newFeatures = { ...selectedFeatures };
									delete newFeatures[feature.key];
									this.setState({ selectedFeatures: newFeatures });
								} else {
									this.handleFeatureToggle(feature.key, feature.type, feature.defaultValue);
								}
							}}
						>
							<Form.Checkbox
								checked={isActive}
								onChange={() => {
									if (!isEditing) return;
									if (selectedFeatures.hasOwnProperty(feature.key)) {
										const newFeatures = { ...selectedFeatures };
										delete newFeatures[feature.key];
										this.setState({ selectedFeatures: newFeatures });
									} else {
										this.handleFeatureToggle(feature.key, feature.type, feature.defaultValue);
									}
								}}
								disabled={!isEditing}
								onClick={(e) => e.stopPropagation()}
							/>
							<div style={{ flex: 1 }}>
								{feature.label} <br></br>
								<div style={{ opacity: 0.5 }}>{feature.key}</div>
							</div>
							{isActive && feature.type === 'string' && (
								<div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
									{isEditing && (
										<Input
											value={value || ''}
											onChange={(e) => this.handleFeatureValueChange(feature.key, e.target.value)}
											placeholder="Değer girin"
											style={{ width: '300px' }}
											onClick={(e) => e.stopPropagation()}
											onFocus={(e) => e.stopPropagation()}
										/>
									)}
								</div>
							)}
							{isActive && feature.type === 'number' && (
								<div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
									{isEditing && (
										<Input
											type="number"
											value={value || 0}
											onChange={(e) => this.handleFeatureValueChange(feature.key, Number(e.target.value))}
											placeholder="Değer girin"
											style={{ width: '150px' }}
											onClick={(e) => e.stopPropagation()}
											onFocus={(e) => e.stopPropagation()}
										/>
									)}
								</div>
							)}
							{isActive && feature.type === 'boolean' && (
								<div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
									<Form.Radio
										toggle
										checked={!!value}
										onChange={(e, { checked }) => this.handleFeatureValueChange(feature.key, checked)}
										disabled={!isEditing}
										onClick={(e) => e.stopPropagation()} // Radio butonuna tıklamayı engelle
									/>
								</div>
							)}

							{isActive && feature.type === 'array' && (
								<div style={{ display: 'flex', gap: '1em', alignItems: 'center' }}>
									<div
										style={{
											padding: '0.5em',
											backgroundColor: '#f8fafc',
											borderRadius: '4px',
											fontSize: '0.9em',
											color: '#475569',
											minWidth: '100px',
											textAlign: 'center',
										}}
									>
										{feature.key === 'custom_emoji'
											? `${value?.list?.[0]?.length || 0} öğe`
											: Array.isArray(value)
											? `${value.length} öğe`
											: '0 öğe'}
									</div>
									{isEditing && (
										<Button
											icon="edit"
											content="Düzenle"
											size="tiny"
											onClick={(e) => {
												e.stopPropagation();
												this.handleArrayEdit(feature.key, value);
											}}
										/>
									)}
								</div>
							)}
							{isActive && feature.type === 'object' && (
								<div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
									{isEditing && (
										<Button
											icon="edit"
											content="Düzenle"
											size="tiny"
											onClick={(e) => {
												e.stopPropagation();
												this.handleObjectEdit(feature.key, value);
											}}
										/>
									)}
									{!isEditing && (
										<div
											style={{
												padding: '0.3em 0.8em',
												borderRadius: '12px',
												fontSize: '0.9em',
												backgroundColor: '#f1f5f9',
												color: '#475569',
											}}
										>
											{Object.keys(value || feature.defaultValue).length} obje
										</div>
									)}
								</div>
							)}

							{!isEditing && isActive && feature.type !== 'array' && (
								<div
									style={{
										padding: '0.3em 0.8em',
										borderRadius: '12px',
										fontSize: '0.9em',
										backgroundColor: feature.type === 'boolean' ? (value ? '#e8f6ef' : '#fef2f2') : '#f1f5f9',
										color: feature.type === 'boolean' ? (value ? '#27ae60' : '#e74c3c') : '#475569',
									}}
								>
									{feature.type === 'boolean' ? (value ? 'Aktif' : 'Pasif') : String(value)}
								</div>
							)}
						</div>
					);
				})}
				{this.renderArrayEditModal()}
			</div>
		);
	};
	handleObjectEdit = (key, value) => {
		this.setState({
			isObjectEditModalOpen: true,
			currentEditingObject: value || this.state.availableFeatures.find((f) => f.key === key).defaultValue,
			currentEditingObjectKey: key,
		});
	};

	renderObjectEditModal = () => {
		const { isObjectEditModalOpen, currentEditingObject, currentEditingObjectKey } = this.state;
		const feature = this.state.availableFeatures.find((f) => f.key === currentEditingObjectKey);

		if (!feature || !isObjectEditModalOpen) return null;

		// search objesi için özel render
		if (currentEditingObjectKey === 'search') {
			return (
				<Modal open={isObjectEditModalOpen} onClose={() => this.setState({ isObjectEditModalOpen: false })} size="small">
					<Modal.Header>Search Ayarları</Modal.Header>
					<Modal.Content>
						<Form>
							<Form.Field>
								<label>Product URL</label>
								<Input
									value={currentEditingObject.product || ''}
									onChange={(e) => {
										this.setState({
											currentEditingObject: {
												...currentEditingObject,
												product: e.target.value,
											},
										});
									}}
									placeholder="URL giriniz"
									fluid
								/>
							</Form.Field>
						</Form>
					</Modal.Content>
					<Modal.Actions>
						<Button onClick={() => this.setState({ isObjectEditModalOpen: false })}>İptal</Button>
						<Button
							color="green"
							onClick={() => {
								this.handleFeatureValueChange(currentEditingObjectKey, currentEditingObject);
								this.setState({
									isObjectEditModalOpen: false,
									currentEditingObject: null,
									currentEditingObjectKey: null,
								});
							}}
						>
							Kaydet
						</Button>
					</Modal.Actions>
				</Modal>
			);
		}

		// widget_config objesi için özel render
		if (currentEditingObjectKey === 'widget_config') {
			return (
				<Modal open={isObjectEditModalOpen} onClose={() => this.setState({ isObjectEditModalOpen: false })} size="small">
					<Modal.Header>Widget Ayarları</Modal.Header>
					<Modal.Content>
						<Form>
							<Form.Field>
								<Form.Checkbox
									label="Label"
									checked={currentEditingObject.label}
									onChange={(e, { checked }) => {
										this.setState({
											currentEditingObject: {
												...currentEditingObject,
												label: checked,
											},
										});
									}}
								/>
							</Form.Field>
							<Form.Field>
								<Form.Checkbox
									label="Ecommerce"
									checked={currentEditingObject.ecommerce}
									onChange={(e, { checked }) => {
										this.setState({
											currentEditingObject: {
												...currentEditingObject,
												ecommerce: checked,
											},
										});
									}}
								/>
							</Form.Field>
							<Form.Field>
								<label>Tiers</label>
								{currentEditingObject.tiers.map((tier, index) => (
									<Segment key={index} style={{ marginBottom: '1em' }}>
										<Form.Group widths="equal">
											<Form.Input
												label="Ext ID"
												value={tier.ext_id}
												onChange={(e) => {
													const newTiers = [...currentEditingObject.tiers];
													newTiers[index] = {
														...tier,
														ext_id: Number(e.target.value),
													};
													this.setState({
														currentEditingObject: {
															...currentEditingObject,
															tiers: newTiers,
														},
													});
												}}
												type="number"
											/>
											<Form.Input
												label="Selected Tier"
												value={tier.selected_tier}
												onChange={(e) => {
													const newTiers = [...currentEditingObject.tiers];
													newTiers[index] = {
														...tier,
														selected_tier: e.target.value,
													};
													this.setState({
														currentEditingObject: {
															...currentEditingObject,
															tiers: newTiers,
														},
													});
												}}
											/>
											<Button
												icon="trash"
												negative
												style={{ marginTop: '24px' }}
												onClick={() => {
													const newTiers = currentEditingObject.tiers.filter((_, i) => i !== index);
													this.setState({
														currentEditingObject: {
															...currentEditingObject,
															tiers: newTiers,
														},
													});
												}}
											/>
										</Form.Group>
									</Segment>
								))}
								<Button
									icon="plus"
									content="Yeni Tier Ekle"
									onClick={() => {
										this.setState({
											currentEditingObject: {
												...currentEditingObject,
												tiers: [...currentEditingObject.tiers, { ext_id: 0, selected_tier: '' }],
											},
										});
									}}
								/>
							</Form.Field>
							<Form.Field>
								<label>Sub Settings</label>
								<Segment>
									<Form.Group>
										<Form.Select
											label="Status"
											options={[
												{ key: 'active', text: 'Active', value: 'active' },
												{ key: 'inactive', text: 'Inactive', value: 'inactive' },
											]}
											value={currentEditingObject.sub.status}
											onChange={(e, { value }) => {
												this.setState({
													currentEditingObject: {
														...currentEditingObject,
														sub: {
															...currentEditingObject.sub,
															status: value,
														},
													},
												});
											}}
										/>
										<Form.Checkbox
											label="Trial"
											checked={currentEditingObject.sub.trial}
											onChange={(e, { checked }) => {
												this.setState({
													currentEditingObject: {
														...currentEditingObject,
														sub: {
															...currentEditingObject.sub,
															trial: checked,
														},
													},
												});
											}}
											style={{ marginLeft: '2em', marginTop: '2em' }}
										/>
									</Form.Group>
								</Segment>
							</Form.Field>
						</Form>
					</Modal.Content>
					<Modal.Actions>
						<Button onClick={() => this.setState({ isObjectEditModalOpen: false })}>İptal</Button>
						<Button
							color="green"
							onClick={() => {
								this.handleFeatureValueChange(currentEditingObjectKey, currentEditingObject);
								this.setState({
									isObjectEditModalOpen: false,
									currentEditingObject: null,
									currentEditingObjectKey: null,
								});
							}}
						>
							Kaydet
						</Button>
					</Modal.Actions>
				</Modal>
			);
		}

		if (currentEditingObjectKey === 'langData') {
			return (
				// return ifadesi eklendi
				<Modal open={isObjectEditModalOpen} onClose={() => this.setState({ isObjectEditModalOpen: false })} size="large">
					<Modal.Header>Dil Ayarları Düzenle</Modal.Header>
					<Modal.Content>
						<div style={{ maxHeight: '600px', overflowY: 'auto' }}>
							{Object.entries(currentEditingObject).map(([lang, data]) => (
								<div key={lang} style={{ marginBottom: '2em' }}>
									<h3
										style={{
											marginBottom: '1em',
											padding: '0.5em',
											backgroundColor: '#f8f9fa',
											borderRadius: '4px',
										}}
									>
										{lang.toUpperCase()}
									</h3>
									{Object.entries(data).map(([key, value]) => (
										<div key={key} style={{ marginBottom: '1em' }}>
											<label
												style={{
													display: 'block',
													marginBottom: '0.5em',
													color: '#666',
												}}
											>
												{key}
											</label>
											<TextArea
												style={{
													width: '100%',
													minHeight: '150px',
													fontFamily: 'monospace',
													fontSize: '14px',
													padding: '1em',
												}}
												value={value}
												onChange={(e) => {
													const newObject = { ...currentEditingObject };
													newObject[lang][key] = e.target.value;
													this.setState({ currentEditingObject: newObject });
												}}
											/>
										</div>
									))}
								</div>
							))}
						</div>
					</Modal.Content>
					<Modal.Actions>
						<Button onClick={() => this.setState({ isObjectEditModalOpen: false })}>İptal</Button>
						<Button
							color="green"
							onClick={() => {
								this.handleFeatureValueChange(currentEditingObjectKey, currentEditingObject);
								this.setState({
									isObjectEditModalOpen: false,
									currentEditingObject: null,
									currentEditingObjectKey: null,
								});
							}}
						>
							Kaydet
						</Button>
					</Modal.Actions>
				</Modal>
			);
		}
		return (
			<Modal open={isObjectEditModalOpen} onClose={() => this.setState({ isObjectEditModalOpen: false })} size="small">
				<Modal.Header>Object Düzenle</Modal.Header>
				<Modal.Content>
					<Form>
						<Form.Field>
							<TextArea
								style={{
									minHeight: '200px',
									fontFamily: 'monospace',
									fontSize: '14px',
								}}
								value={JSON.stringify(currentEditingObject, null, 2)}
								onChange={(e) => {
									try {
										const parsed = JSON.parse(e.target.value);
										this.setState({ currentEditingObject: parsed });
									} catch (err) {
										// JSON parse hatası durumunda bir şey yapma
									}
								}}
							/>
						</Form.Field>
					</Form>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={() => this.setState({ isObjectEditModalOpen: false })}>İptal</Button>
					<Button
						color="green"
						onClick={() => {
							this.handleFeatureValueChange(currentEditingObjectKey, currentEditingObject);
							this.setState({
								isObjectEditModalOpen: false,
								currentEditingObject: null,
								currentEditingObjectKey: null,
							});
						}}
					>
						Kaydet
					</Button>
				</Modal.Actions>
			</Modal>
		);
	};
	renderWhatsAppTemplate = (template) => {
		return (
			<div
				style={{
					border: 'none',
					borderRadius: '12px',
					padding: '1.5em',
					marginBottom: '1.5em',
					backgroundColor: '#fff',
					boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
					transition: 'all 0.3s ease',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						marginBottom: '1.5em',
						alignItems: 'center',
						borderBottom: '1px solid #f0f0f0',
						paddingBottom: '1em',
					}}
				>
					<div
						style={{
							fontSize: '1.2em',
							fontWeight: '600',
							color: '#1a1a1a',
							letterSpacing: '-0.02em',
						}}
					>
						{template.name}
					</div>
					<div
						style={{
							display: 'flex',
							gap: '0.8em',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								padding: '0.4em 1em',
								borderRadius: '20px',
								fontSize: '0.85em',
								fontWeight: '500',
								backgroundColor: template.status === 'approved' ? '#e8f6ef' : '#fef2f2',
								color: template.status === 'approved' ? '#27ae60' : '#e74c3c',
								border: `1px solid ${template.status === 'approved' ? '#d1fae5' : '#fee2e2'}`,
							}}
						>
							{template.status}
						</div>
						<div
							style={{
								padding: '0.4em 1em',
								borderRadius: '20px',
								fontSize: '0.85em',
								fontWeight: '500',
								backgroundColor: '#f1f5f9',
								color: '#475569',
								border: '1px solid #e2e8f0',
							}}
						>
							{template.language.toUpperCase()}
						</div>
					</div>
				</div>

				<div style={{ display: 'grid', gap: '1.2em' }}>
					{template.components.map((component, index) => (
						<div
							key={index}
							style={{
								padding: '1em',
								backgroundColor: '#f8fafc',
								borderRadius: '8px',
								border: '1px solid #edf2f7',
							}}
						>
							{component.type === 'HEADER' && (
								<div>
									<div
										style={{
											color: '#64748b',
											marginBottom: '0.8em',
											fontSize: '0.9em',
											fontWeight: '500',
											textTransform: 'uppercase',
											letterSpacing: '0.05em',
										}}
									>
										HEADER
									</div>
									{component.format === 'IMAGE' ? (
										<img
											src={component.example?.header_handle?.[0]}
											alt="Header"
											style={{
												maxWidth: '200px',
												borderRadius: '8px',
												border: '1px solid #e2e8f0',
											}}
										/>
									) : (
										<div
											style={{
												padding: '0.8em',
												backgroundColor: '#fff',
												borderRadius: '6px',
												border: '1px solid #e2e8f0',
												color: '#334155',
											}}
										>
											{component.text}
										</div>
									)}
								</div>
							)}

							{component.type === 'BODY' && (
								<div>
									<div
										style={{
											color: '#64748b',
											marginBottom: '0.8em',
											fontSize: '0.9em',
											fontWeight: '500',
											textTransform: 'uppercase',
											letterSpacing: '0.05em',
										}}
									>
										BODY
									</div>
									<div
										style={{
											padding: '0.8em',
											backgroundColor: '#fff',
											borderRadius: '6px',
											border: '1px solid #e2e8f0',
											color: '#334155',
											whiteSpace: 'pre-wrap',
											lineHeight: '1.5',
										}}
									>
										{component.text}
									</div>
								</div>
							)}

							{component.type === 'FOOTER' && (
								<div>
									<div
										style={{
											color: '#64748b',
											marginBottom: '0.8em',
											fontSize: '0.9em',
											fontWeight: '500',
											textTransform: 'uppercase',
											letterSpacing: '0.05em',
										}}
									>
										FOOTER
									</div>
									<div
										style={{
											padding: '0.8em',
											backgroundColor: '#fff',
											borderRadius: '6px',
											border: '1px solid #e2e8f0',
											color: '#334155',
										}}
									>
										{component.text}
									</div>
								</div>
							)}

							{component.type === 'BUTTONS' && (
								<div>
									<div
										style={{
											color: '#64748b',
											marginBottom: '0.8em',
											fontSize: '0.9em',
											fontWeight: '500',
											textTransform: 'uppercase',
											letterSpacing: '0.05em',
										}}
									>
										BUTTONS
									</div>
									<div style={{ display: 'flex', gap: '0.8em' }}>
										{component.buttons.map((button, btnIndex) => (
											<div
												key={btnIndex}
												style={{
													padding: '0.6em 1.2em',
													backgroundColor: button.type === 'URL' ? '#3b82f6' : '#10b981',
													color: '#fff',
													borderRadius: '6px',
													fontSize: '0.9em',
													fontWeight: '500',
													cursor: button.type === 'URL' ? 'pointer' : 'default',
													transition: 'all 0.2s ease',
													boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
													border: button.type === 'URL' ? '1px solid #2563eb' : '1px solid #059669',
												}}
												onClick={() => button.type === 'URL' && window.open(button.url, '_blank')}
											>
												{button.text}
											</div>
										))}
									</div>
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		);
	};

	renderJsonCard = (data, label) => {
		return (
			<div
				style={{
					border: 'none',
					borderRadius: '12px',
					padding: '1.5em',
					marginBottom: '1.5em',
					backgroundColor: '#fff',
					boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
					transition: 'all 0.3s ease',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						marginBottom: '1.5em',
						alignItems: 'center',
						borderBottom: '1px solid #f0f0f0',
						paddingBottom: '1em',
					}}
				>
					<div
						style={{
							fontSize: '1.2em',
							fontWeight: '600',
							color: '#1a1a1a',
							letterSpacing: '-0.02em',
						}}
					>
						{label}
					</div>
				</div>
				<div style={{ display: 'grid', gap: '1.2em' }}>
					{Object.entries(data).map(([key, value], index) => (
						<div
							key={index}
							style={{
								padding: '1em',
								backgroundColor: '#f8fafc',
								borderRadius: '8px',
								border: '1px solid #edf2f7',
								transition: 'all 0.2s ease',
							}}
						>
							<div
								style={{
									color: '#64748b',
									marginBottom: '0.5em',
									fontSize: '0.9em',
									fontWeight: '500',
									textTransform: 'uppercase',
									letterSpacing: '0.05em',
								}}
							>
								{key}
							</div>
							<div
								style={{
									padding: '0.8em',
									backgroundColor: '#fff',
									borderRadius: '6px',
									border: '1px solid #e2e8f0',
									fontSize: '0.95em',
									color: '#334155',
									whiteSpace: 'pre-wrap',
									fontFamily: typeof value === 'object' ? 'monospace' : 'inherit',
									lineHeight: '1.5',
								}}
							>
								{typeof value === 'object' ? (
									JSON.stringify(value, null, 2)
								) : typeof value === 'boolean' ? (
									<div
										style={{
											display: 'inline-block',
											padding: '0.3em 0.8em',
											borderRadius: '12px',
											backgroundColor: value ? '#e8f6ef' : '#fef2f2',
											color: value ? '#27ae60' : '#e74c3c',
											fontSize: '0.9em',
											fontWeight: '500',
										}}
									>
										{value ? 'Aktif' : 'Pasif'}
									</div>
								) : (
									String(value)
								)}
							</div>
						</div>
					))}
				</div>
			</div>
		);
	};

	// JSON düzenleme için yardımcı fonksiyon
	handleJsonEdit = (path, rawValue, type = 'object') => {
		try {
			// Boş string kontrolü
			if (!rawValue || !rawValue.trim()) {
				this.handleDataChange(path, type === 'array' ? [] : {});
				return;
			}

			// JSON formatını düzelt
			let cleanValue = rawValue
				.replace(/[\u0000-\u0019]+/g, '') // Kontrol karakterlerini temizle
				.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2":') // Key'leri düzelt
				.replace(/'/g, '"') // Tek tırnakları çift tırnağa çevir
				.trim();

			// JSON parse işlemi
			let parsed;
			try {
				parsed = JSON.parse(cleanValue);
			} catch (parseError) {
				// Eğer parse hatası varsa, otomatik düzeltme dene
				cleanValue = cleanValue
					.replace(/,\s*([\]}])/g, '$1') // Sondaki gereksiz virgülleri temizle
					.replace(/\s*:\s*/g, ': ') // Key-value ayraçlarını düzenle
					.replace(/([{,]\s*)([^"'\s][^:]*?):/g, '$1"$2":'); // Tırnaksız key'leri düzelt

				parsed = JSON.parse(cleanValue);
			}

			// Tip kontrolü
			if (type === 'array' && !Array.isArray(parsed)) {
				throw new Error('Veri array formatında olmalıdır.');
			}

			// State güncelleme
			this.handleDataChange(path, parsed);
			this.setState({ saveError: null }); // Başarılı olursa hata mesajını temizle
		} catch (err) {
			console.log('JSON parse hatası:', err);
			this.setState({
				saveError: `JSON formatı geçerli değil: ${err.message}`,
			});
		}
	};

	renderEditableField = (label, path, type = 'text') => {
		const { isEditing, editedData, editingSection, selectedAccount } = this.state;

		const currentData = isEditing ? editedData : selectedAccount[editingSection];
		const value = _.get(currentData, path);

		const commonStyles = {
			padding: '0.8em',
			backgroundColor: '#f8f9fa',
			borderRadius: '4px',
			marginBottom: '0.5em',
		};

		const inputStyles = {
			width: '100%',
			padding: '0.5em',
			borderRadius: '4px',
			border: '1px solid #ddd',
			fontFamily: type === 'code' ? 'monospace' : 'inherit',
		};

		const searchStyles = {
			marginBottom: '1em',
			width: '100%',
		};

		const contentContainerStyle = {
			maxHeight: '600px',
			overflowY: 'auto',
			padding: '0.5em',
			backgroundColor: '#fff',
			borderRadius: '8px',
			border: '1px solid #edf2f7',
		};

		if (path === 'wa_templates') {
			const searchQuery = this.state[`${path}_search`] || '';
			const filteredTemplates = value ? value.filter((template) => JSON.stringify(template).toLowerCase().includes(searchQuery.toLowerCase())) : [];

			return (
				<div>
					{!isEditing && (
						<Input
							icon="search"
							placeholder="Şablonlarda ara..."
							value={searchQuery}
							onChange={(e) => this.setState({ [`${path}_search`]: e.target.value })}
							style={searchStyles}
						/>
					)}
					{isEditing ? (
						<div>
							<div style={{ marginBottom: '1em', color: '#666', fontSize: '0.9em' }}>
								JSON formatında düzenleyin. Yeni öğeler ekleyebilir veya mevcut yapıyı değiştirebilirsiniz.
								<br />
								<span style={{ color: '#888', fontSize: '0.9em' }}>
									Not: Key'ler çift tırnak içinde olmalıdır. Örnek: {`{ "name": "value" }`}
								</span>
							</div>
							<TextArea
								style={{
									...inputStyles,
									minHeight: '400px',
									maxHeight: '600px',
									overflowY: 'auto',
									fontFamily: 'monospace',
									fontSize: '14px',
									lineHeight: '1.5',
								}}
								value={JSON.stringify(value || [], null, 2)}
								onChange={(e) => this.handleJsonEdit(path, e.target.value, 'array')}
								spellCheck="false"
							/>
							{this.state.saveError && (
								<div
									style={{
										color: '#e74c3c',
										marginTop: '0.5em',
										fontSize: '0.9em',
										padding: '0.5em',
										backgroundColor: '#fef2f2',
										borderRadius: '4px',
									}}
								>
									{this.state.saveError}
								</div>
							)}
						</div>
					) : (
						<div style={contentContainerStyle}>
							{filteredTemplates.map((template, index) => (
								<div key={index}>{this.renderWhatsAppTemplate(template)}</div>
							))}
						</div>
					)}
				</div>
			);
		}

		if (type === 'object' || type === 'json') {
			const searchQuery = this.state[`${path}_search`] || '';
			const jsonData = value || {};
			const filteredData = searchQuery
				? Object.fromEntries(
						Object.entries(jsonData).filter(([key, val]) =>
							JSON.stringify({ [key]: val })
								.toLowerCase()
								.includes(searchQuery.toLowerCase())
						)
				  )
				: jsonData;

			return (
				<div>
					{!isEditing && (
						<Input
							icon="search"
							placeholder="JSON içinde ara..."
							value={searchQuery}
							onChange={(e) => this.setState({ [`${path}_search`]: e.target.value })}
							style={searchStyles}
						/>
					)}
					{isEditing ? (
						<div>
							<div style={{ marginBottom: '1em', color: '#666', fontSize: '0.9em' }}>
								JSON formatında düzenleyin. Yeni öğeler ekleyebilir veya mevcut yapıyı değiştirebilirsiniz.
							</div>
							<TextArea
								style={{
									...inputStyles,
									minHeight: '400px',
									maxHeight: '600px',
									overflowY: 'auto',
									fontFamily: 'monospace',
									fontSize: '14px',
									lineHeight: '1.5',
								}}
								value={JSON.stringify(value || {}, null, 2)}
								onChange={(e) => this.handleJsonEdit(path, e.target.value)}
								spellCheck="false"
							/>
							{this.state.saveError && (
								<div
									style={{
										color: '#e74c3c',
										marginTop: '0.5em',
										fontSize: '0.9em',
										padding: '0.5em',
										backgroundColor: '#fef2f2',
										borderRadius: '4px',
									}}
								>
									{this.state.saveError}
								</div>
							)}
						</div>
					) : (
						<div style={contentContainerStyle}>{this.renderJsonCard(filteredData, label)}</div>
					)}
				</div>
			);
		}

		if (type === 'boolean') {
			return (
				<div style={commonStyles}>
					{isEditing ? (
						<Form.Radio label={label} checked={!!value} onChange={(e, { checked }) => this.handleDataChange(path, checked)} toggle />
					) : (
						<div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
							<div>{label}</div>
							<div
								style={{
									padding: '0.3em 0.8em',
									borderRadius: '12px',
									fontSize: '0.9em',
									backgroundColor: value ? '#e8f6ef' : '#fef2f2',
									color: value ? '#27ae60' : '#e74c3c',
								}}
							>
								{value ? 'Aktif' : 'Pasif'}
							</div>
						</div>
					)}
				</div>
			);
		}

		if (type === 'array') {
			const searchQuery = this.state[`${path}_search`] || '';
			const arrayValue = value || [];
			const filteredArray = searchQuery
				? arrayValue.filter((item) => JSON.stringify(item).toLowerCase().includes(searchQuery.toLowerCase()))
				: arrayValue;

			return (
				<div style={commonStyles}>
					<div style={{ color: '#666', marginBottom: '0.5em' }}>{label}</div>
					{!isEditing && (
						<Input
							icon="search"
							placeholder="Liste içinde ara..."
							value={searchQuery}
							onChange={(e) => this.setState({ [`${path}_search`]: e.target.value })}
							style={searchStyles}
						/>
					)}
					{isEditing ? (
						<div>
							{arrayValue.map((item, index) => (
								<div key={index} style={{ marginBottom: '0.5em', display: 'flex', gap: '0.5em' }}>
									<Input
										style={{ flex: 1 }}
										value={item}
										onChange={(e) => {
											const newArray = [...arrayValue];
											newArray[index] = e.target.value;
											this.handleDataChange(path, newArray);
										}}
									/>
									<Button
										icon="trash"
										onClick={() => {
											const newArray = arrayValue.filter((_, i) => i !== index);
											this.handleDataChange(path, newArray);
										}}
									/>
								</div>
							))}
							<Button
								icon="plus"
								content="Yeni Ekle"
								onClick={() => {
									this.handleDataChange(path, [...arrayValue, '']);
								}}
							/>
						</div>
					) : (
						<div
							style={{
								...inputStyles,
								backgroundColor: '#f8f9fa',
								maxHeight: '300px',
								overflowY: 'auto',
							}}
						>
							{filteredArray.map((item, index) => (
								<div key={index} style={{ padding: '0.3em 0' }}>
									{item}
								</div>
							))}
						</div>
					)}
				</div>
			);
		}

		return (
			<div style={commonStyles}>
				<div style={{ color: '#666', marginBottom: '0.5em' }}>{label}</div>
				{isEditing ? (
					<Input style={inputStyles} value={value || ''} onChange={(e) => this.handleDataChange(path, e.target.value)} />
				) : (
					<div
						style={{
							...inputStyles,
							backgroundColor: '#f8f9fa',
						}}
					>
						{value || ''}
					</div>
				)}
			</div>
		);
	};

	renderAccountDetails = () => {
		const { isModalOpen, selectedAccount, isEditing } = this.state;
		if (!selectedAccount) return null;

		return (
			<Modal open={isModalOpen} onClose={() => !isEditing && this.closeModal()} size="large" closeOnDimmerClick={!isEditing} closeOnEscape={!isEditing}>
				<Modal.Header>Hesap Detayları</Modal.Header>
				<Modal.Content>
					<div style={{ display: 'flex', flexDirection: 'column', gap: '1.5em' }}>
						<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1em' }}>
							<div
								style={{
									padding: '1em',
									backgroundColor: '#fff',
									borderRadius: '8px',
									border: '1px solid #edf2f7',
								}}
							>
								<div style={{ color: '#64748b', marginBottom: '0.5em', fontSize: '0.9em' }}>Token</div>
								<div
									style={{
										padding: '0.8em',
										backgroundColor: '#f8fafc',
										borderRadius: '4px',
										color: '#334155',
										fontFamily: 'monospace',
									}}
								>
									{selectedAccount.token}
								</div>
							</div>
							<div
								style={{
									padding: '1em',
									backgroundColor: '#fff',
									borderRadius: '8px',
									border: '1px solid #edf2f7',
								}}
							>
								<div style={{ color: '#64748b', marginBottom: '0.5em', fontSize: '0.9em' }}>SToken</div>
								<div
									style={{
										padding: '0.8em',
										backgroundColor: '#f8fafc',
										borderRadius: '4px',
										color: '#334155',
										fontFamily: 'monospace',
									}}
								>
									{selectedAccount.stoken}
								</div>
							</div>
						</div>

						<div
							style={{
								backgroundColor: '#fff',
								borderRadius: '8px',
								border: '1px solid #edf2f7',
								overflow: 'hidden',
							}}
						>
							<Accordion fluid styled>
								<Accordion.Title
									active={this.state.activeBotInfo}
									onClick={() => this.setState((prevState) => ({ activeBotInfo: !prevState.activeBotInfo }))}
									style={{
										backgroundColor: '#f8fafc',
										borderBottom: '1px solid #edf2f7',
										padding: '1em',
										display: 'flex',
										alignItems: 'center',
										gap: '0.5em',
									}}
								>
									<Icon name={this.state.activeBotInfo ? 'angle down' : 'angle right'} />
									<span style={{ fontWeight: '500', color: '#334155' }}>Bot Bilgileri</span>
								</Accordion.Title>
								<Accordion.Content active={this.state.activeBotInfo}>
									<div style={{ padding: '1em' }}>
										{selectedAccount.bot ? (
											<div style={{ display: 'grid', gap: '1em' }}>
												{['id', 'bid', 'wid', 'type'].map((field) => (
													<div key={field} style={{ marginBottom: '0.5em' }}>
														<span style={{ color: '#64748b', fontSize: '0.9em', textTransform: 'uppercase' }}>{field}:</span>
														<div
															style={{
																padding: '0.8em',
																backgroundColor: '#f8fafc',
																borderRadius: '4px',
																marginTop: '0.2em',
																color: '#334155',
																fontFamily: field !== 'type' ? 'monospace' : 'inherit',
															}}
														>
															{selectedAccount.bot[field] || '-'}
														</div>
													</div>
												))}
											</div>
										) : (
											<div style={{ color: '#64748b', padding: '1em' }}>Bot bilgisi bulunamadı</div>
										)}
									</div>
								</Accordion.Content>

								<Accordion.Title
									active={this.state.activeBotsList}
									onClick={() => this.setState((prevState) => ({ activeBotsList: !prevState.activeBotsList }))}
									style={{
										backgroundColor: '#f8fafc',
										borderBottom: '1px solid #edf2f7',
										padding: '1em',
										display: 'flex',
										alignItems: 'center',
										gap: '0.5em',
									}}
								>
									<Icon name={this.state.activeBotsList ? 'angle down' : 'angle right'} />
									<span style={{ fontWeight: '500', color: '#334155' }}>Agents Listesi</span>
								</Accordion.Title>
								<Accordion.Content active={this.state.activeBotsList}>
									<div style={{ padding: '1em', maxHeight: '400px', overflowY: 'auto' }}>
										{selectedAccount.agents && selectedAccount.agents.length > 0 ? (
											<div style={{ display: 'grid', gap: '1em' }}>
												{selectedAccount.agents.map((agent, index) => (
													<div
														key={index}
														style={{
															backgroundColor: '#f8fafc',
															borderRadius: '8px',
															border: '1px solid #edf2f7',
															padding: '1em',
														}}
													>
														<div
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																marginBottom: '0.8em',
																alignItems: 'center',
															}}
														>
															<span style={{ fontWeight: '500', color: '#334155' }}>{agent.developer}</span>
															<div
																style={{
																	padding: '0.3em 0.8em',
																	borderRadius: '12px',
																	fontSize: '0.85em',
																	backgroundColor: '#f1f5f9',
																	color: '#475569',
																}}
															>
																{agent.type || 'Belirtilmemiş'}
															</div>
														</div>
														<div style={{ display: 'grid', gap: '0.5em', fontSize: '0.9em' }}>
															<div>
																<span style={{ color: '#64748b' }}>İsim: </span>
																<span style={{ color: '#334155' }}>{agent.fullname || 'Belirtilmemiş'}</span>
															</div>
															<div>
																<span style={{ color: '#64748b' }}>Grup: </span>
																<span style={{ color: '#334155' }}>{agent.group || 'Belirtilmemiş'}</span>
															</div>
														</div>
													</div>
												))}
											</div>
										) : (
											<div style={{ color: '#64748b', padding: '1em' }}>Tanımlı agent bulunamadı</div>
										)}
									</div>
								</Accordion.Content>
							</Accordion>
						</div>

						<div style={{ display: 'flex', gap: '1em', marginTop: '1em' }}>
							<Button color="teal" onClick={this.openClientModal}>
								Client Detayları
							</Button>
							<Button color="violet" onClick={this.openStaticOptionsModal}>
								Static Options
							</Button>
						</div>
					</div>
				</Modal.Content>
				<Modal.Actions style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #dee2e6' }}>
					<Button onClick={this.closeModal} disabled={isEditing}>
						Kapat
					</Button>
				</Modal.Actions>
			</Modal>
		);
	};

	renderClientDetails = () => {
		const { selectedAccount, isEditing, isSaving, saveError, saveMessage } = this.state;
		if (!selectedAccount?.client) return null;

		return (
			<Modal
				open={this.state.isClientModalOpen}
				onClose={() => !isEditing && this.setState({ isClientModalOpen: false })}
				size="fullscreen"
				style={{ height: '90vh' }}
				closeOnDimmerClick={!isEditing}
				closeOnEscape={!isEditing}
			>
				<Modal.Header
					style={{
						backgroundColor: '#f8f9fa',
						borderBottom: '1px solid #dee2e6',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<div>Client Bilgileri</div>
					<div style={{ display: 'flex', gap: '1em' }}>
						{isEditing ? (
							<>
								<Button color="grey" onClick={() => this.handleEditToggle('client')} disabled={isSaving}>
									İptal
								</Button>
								<Button color="green" onClick={this.handleSave} loading={isSaving} disabled={isSaving}>
									Kaydet
								</Button>
							</>
						) : (
							<Button color="blue" onClick={() => this.handleEditToggle('client')}>
								Düzenle
							</Button>
						)}
					</div>
				</Modal.Header>
				{saveError && (
					<div
						style={{
							padding: '1em',
							margin: '1em',
							backgroundColor: '#fff3f3',
							color: '#e74c3c',
							borderRadius: '4px',
							border: '1px solid #ffd7d7',
						}}
					>
						Hata: {saveError}
					</div>
				)}
				{saveMessage && this.renderSuccessMessage()}
				<Modal.Content scrolling style={{ padding: '2em' }}>
					<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '2em' }}>
						<Segment basic style={{ margin: 0, padding: '1.5em', backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
							<h4
								style={{
									color: '#34495e',
									marginBottom: '1em',
									fontSize: '1.1em',
									borderBottom: '2px solid #3498db',
									paddingBottom: '0.5em',
									display: 'inline-block',
								}}
							>
								Client Bilgileri
							</h4>
							{/* Client bilgileri buraya gelecek */}
						</Segment>
					</div>
				</Modal.Content>
				<Modal.Actions style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #dee2e6' }}>
					<Button onClick={() => this.setState({ isClientModalOpen: false })} disabled={isEditing}>
						Kapat
					</Button>
				</Modal.Actions>
			</Modal>
		);
	};

	renderStaticOptionsDetails = () => {
		const { selectedAccount, isEditing, isSaving, saveError, saveMessage } = this.state;
		if (!selectedAccount?.staticOptions) return null;

		// Filtreleme fonksiyonları
		const filterFeatures = () => {
			const features = this.state.availableFeatures;
			const filterType = this.state.featureFilterType || 'all';
			const searchQuery = this.state.featureSearch || '';
			let filteredFeatures = features;

			// Önce arama filtresini uygula
			if (searchQuery) {
				filteredFeatures = features.filter(
					(feature) =>
						feature.label.toLowerCase().includes(searchQuery.toLowerCase()) || feature.key.toLowerCase().includes(searchQuery.toLowerCase())
				);
			}

			// Sonra seçilen filtre tipine göre filtrele
			switch (filterType) {
				case 'same':
					return filteredFeatures.filter((feature) => feature.key === feature.label);
				case 'different':
					return filteredFeatures.filter((feature) => feature.key !== feature.label);
				default:
					return filteredFeatures;
			}
		};

		return (
			<Modal
				open={this.state.isStaticOptionsModalOpen}
				onClose={() => !isEditing && this.setState({ isStaticOptionsModalOpen: false })}
				size="fullscreen"
				style={{ height: '90vh' }}
				closeOnDimmerClick={!isEditing}
				closeOnEscape={!isEditing}
			>
				<Modal.Header
					style={{
						backgroundColor: '#f8f9fa',
						borderBottom: '1px solid #dee2e6',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<div>Static Options</div>
					<div style={{ display: 'flex', gap: '1em' }}>
						{isEditing ? (
							<>
								<Button color="grey" onClick={() => this.handleEditToggle('staticOptions')} disabled={isSaving}>
									İptal
								</Button>
								<Button color="green" onClick={this.handleSave} loading={isSaving} disabled={isSaving}>
									Kaydet
								</Button>
							</>
						) : (
							<Button color="blue" onClick={() => this.handleEditToggle('staticOptions')}>
								Düzenle
							</Button>
						)}
					</div>
				</Modal.Header>
				{saveError && (
					<div
						style={{
							padding: '1em',
							margin: '1em',
							backgroundColor: '#fff3f3',
							color: '#e74c3c',
							borderRadius: '4px',
							border: '1px solid #ffd7d7',
						}}
					>
						Hata: {saveError}
					</div>
				)}
				{saveMessage && this.renderSuccessMessage()}
				<Modal.Content scrolling style={{ padding: '2em' }}>
					<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '2em' }}>
						<Segment basic style={{ margin: 0, padding: '1.5em', backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
							<div style={{ marginBottom: '1em' }}>
								<h4
									style={{
										color: '#34495e',
										marginBottom: '1em',
										fontSize: '1.1em',
										borderBottom: '2px solid #3498db',
										paddingBottom: '0.5em',
										display: 'inline-block',
									}}
								>
									Özellikler
								</h4>

								{/* Filtreleme butonları */}
								<div style={{ marginBottom: '1em', display: 'flex', gap: '1em' }}>
									<Button
										color={this.state.featureFilterType === 'all' ? 'blue' : 'grey'}
										onClick={() => this.setState({ featureFilterType: 'all' })}
									>
										Tümü
									</Button>
									<Button
										color={this.state.featureFilterType === 'same' ? 'blue' : 'grey'}
										onClick={() => this.setState({ featureFilterType: 'same' })}
									>
										Text Belirtilmemiş
									</Button>
									<Button
										color={this.state.featureFilterType === 'different' ? 'blue' : 'grey'}
										onClick={() => this.setState({ featureFilterType: 'different' })}
									>
										Text Belirtilmiş
									</Button>
								</div>

								{/* Search input */}
								<Input
									icon="search"
									placeholder="Özellikler içinde ara..."
									value={this.state.featureSearch}
									onChange={(e) => this.setState({ featureSearch: e.target.value })}
									style={{
										width: '400px',
										marginBottom: '1em',
									}}
								/>
								<div style={{ clear: 'both' }}></div>
							</div>
							{/* Filtrelenmiş feature listesini render et */}
							<div className="feature-list">{this.renderFeatureList(filterFeatures())}</div>
						</Segment>
					</div>
				</Modal.Content>
				<Modal.Actions style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #dee2e6' }}>
					<Button onClick={() => this.setState({ isStaticOptionsModalOpen: false })} disabled={isEditing}>
						Kapat
					</Button>
				</Modal.Actions>
			</Modal>
		);
	};

	renderSuccessMessage = () => {
		const { saveMessage } = this.state;
		if (!saveMessage) return null;

		return (
			<div
				style={{
					padding: '1em',
					margin: '1em',
					backgroundColor: saveMessage.type === 'success' ? '#e8f6ef' : '#fff3f3',
					color: saveMessage.type === 'success' ? '#27ae60' : '#e74c3c',
					borderRadius: '4px',
					border: `1px solid ${saveMessage.type === 'success' ? '#b8e6d2' : '#ffd7d7'}`,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
			>
				<div>{saveMessage.content}</div>
			</div>
		);
	};

	render() {
		const { column, direction, loading, data, error, page, limit, totalPages, searchToken, searchTimeout, currentPageData } = this.state;

		if (loading) return <Segment>Yükleniyor...</Segment>;
		if (error) return <Segment color="red">Hata: {error}</Segment>;

		const limitOptions = [
			{ key: '10', text: '10', value: 10 },
			{ key: '20', text: '20', value: 20 },
			{ key: '50', text: '50', value: 50 },
			{ key: '100', text: '100', value: 100 },
		];

		const displayData = currentPageData || data.slice((page - 1) * limit, page * limit);

		return (
			<div style={{ padding: '0 20px' }}>
				<div style={{ marginBottom: '1em', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<span style={{ marginRight: '1em' }}>Sayfa başına gösterim:</span>
						<Dropdown selection compact options={limitOptions} value={limit} onChange={this.handleLimitChange} />
					</div>
					<div>
						<Input
							icon={searchTimeout ? 'spinner' : 'search'}
							loading={!!searchTimeout}
							placeholder="Developer ara... (En az 2 karakter)"
							value={searchToken}
							onChange={this.handleSearchChange}
							style={{ width: '400px' }}
						/>
					</div>
					<Pagination activePage={page} totalPages={totalPages} onPageChange={this.handlePageChange} size="mini" />
				</div>
				<Table celled sortable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell sorted={column === 'developer' ? direction : null} onClick={this.handleSort('developer')}>
								Developer
							</Table.HeaderCell>
							<Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
								İsim
							</Table.HeaderCell>
							<Table.HeaderCell>Agents</Table.HeaderCell>
							<Table.HeaderCell>İşlemler</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{displayData.map((account) => (
							<Table.Row key={account._id}>
								<Table.Cell>{account.developer}</Table.Cell>
								<Table.Cell>{account.name}</Table.Cell>
								<Table.Cell>
									{account.agents && account.agents.length > 0 ? (
										<Label color="green">{account.developer ? account.agents.length + 1 : account.agents.length} agent</Label>
									) : (
										<Label>{account.developer ? '1 agent' : 'Tanımlı agent yok'}</Label>
									)}
								</Table.Cell>
								<Table.Cell>
									<Button color="blue" onClick={() => this.selectAccount(account)} loading={this.state.loadingAccount === account._id}>
										Detaylar
									</Button>
								</Table.Cell>
							</Table.Row>
						))}
					</Table.Body>
				</Table>
				<div style={{ marginTop: '1em', display: 'flex', justifyContent: 'center' }}>
					<Pagination activePage={page} totalPages={totalPages} onPageChange={this.handlePageChange} />
				</div>
				{this.renderAccountDetails()}
				{this.renderClientDetails()}
				{this.renderStaticOptionsDetails()}
				{this.renderObjectEditModal()}
			</div>
		);
	}
}
